import { useState, useEffect } from 'react';
import useModal, { MODAL_LG, MODAL_md } from '../../../../theme/Component/hooks/useModal';
import useDataBean from '../../../../../core/services/dataBean/useDataBean';
import { _Appointment } from '../../../../../core/services/dataBean/EntityCatalog';
import { Modal } from '../../../../theme/Component/Modal';
import { BasicTable } from '../../../../theme/Component/BasicTable';


interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
    returnType?: "ID" | "Object";
    render?: string;
    disable?:boolean;
}

export const AppointmentCatalog = ({ idSelector, onChange, label, returnType = "ID", disable=false,render }: Props) => {

    const { instance, lista, setLista } = useDataBean(_Appointment)
    const [id, setID] = useState<number>();
    const [renderVal, setRenderVal] = useState<string>(render ?? "")

    const modal = useModal("Nivel Salarial", MODAL_LG);

    useEffect(() => {
        if (idSelector != id) {
            instance.getAppointment(idSelector).then(
                (resp) => {
                    setID(resp.IDAppointment)
                    setRenderVal(resp.Name)
                    onChange(resp)
                }
            ).catch(err => { })
        }
    }, [idSelector])

    useEffect(() => {
        getLista();
    }, [])

    const setValue = (e: string) => {
        const selectedId = parseInt(e);
        setID(selectedId);
        if (onChange) {
            const selectedItem = lista.find(
                (item) => item?.DataBeanProperties?.IDAppointment == e
            );
            setRenderVal(selectedItem.DataBeanProperties.Name)
            if (selectedItem) {
                onChange(returnType === "Object" ? selectedItem?.DataBeanProperties : selectedId);
            } else {
                onChange(returnType === "Object" ? {} : null);
            }
        }
    };


    const getLista = () => {

        instance.getAppointmentCatalog().then(
            (resp: any) => {
                if (resp) {
                    console.log();

                    setLista(resp)
                }
            }
        ).catch(err => { console.log(err) })
    }
    const head = [
        { title: 'ID', property: 'IDAppointment', visible: true },
        { title: 'Código', property: 'Code', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Salario', property: 'Salary', visible: true }
    ]
    const abrirModal = () => {
        modal.open();
    }


    return (
        <>
            <label>{label ?? "Recurso"}</label>
            <span onClick={!disable ? abrirModal : null} className="form-control text-wrap" style={{ minHeight: "35px" }} >{renderVal}</span>
            <Modal modal={modal.modal} updateModal={modal.setModal}>
                <BasicTable head={head} body={lista} rowSet={(e) => { setValue(e.IDAppointment); modal.close(); }}></BasicTable>
            </Modal>
        </>
    )
}